module.exports = __webpack_public_path__ + "static/media/turntable-pointer.019bc908.png";